import {AccountHolderNameSource} from './types';

export const missingApiValue = 'TBD';

const normalizeName = (value?: string) => value?.trim().replace(/\s+/g, ' ') || '';

const endsWithNamePart = (name: string, namePart: string) => {
  const normalizedName = name.toLowerCase();
  const normalizedNamePart = namePart.toLowerCase();
  return normalizedName === normalizedNamePart || normalizedName.endsWith(` ${normalizedNamePart}`);
};

export const buildAccountHolderName = (user?: AccountHolderNameSource) => {
  const realName = normalizeName(user?.realName);
  const firstName = normalizeName(user?.firstname);
  const lastName = normalizeName(user?.lastname);

  if (realName && lastName && !endsWithNamePart(realName, lastName)) return `${realName} ${lastName}`;
  if (realName) return realName;
  return [firstName, lastName].filter(Boolean).join(' ');
};

export const formatDepositMoney = (value: number) => new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2
}).format(value);
